export const COACHES_URL_PART = 'coaches'
